import Backbone from 'backbone';
import $ from 'jquery';

Backbone.$ = $;
